/**
 * Les KPI du dashboard — déplacé depuis `pages/dashboard/api/` par #87.
 *
 * #22 décide que les rendus mobiles sont « alimentés par les hooks de
 * `pages/dashboard/api/` ». Ce n'était pas applicable : la frontière de #23,
 * durcie par #74, interdit à `src/mobile/` d'atteindre `src/pages/` — y compris
 * indirectement, et `mobile:check` le refuse à juste titre.
 *
 * Le hook ne dépendait que de zones PARTAGÉES (`api/`, `contexts/`), il n'y avait
 * donc rien à démêler : c'est exactement le cas que le message du garde-fou
 * prescrit — « extraction en module feuille vers api/ contexts/ helpers/ ». Pas
 * d'exception sur la frontière, et pas de duplication non plus.
 */
import { useApiQuery } from "../useApi";
import { useStateContext } from "../../contexts/ContextProvider";

export interface DashboardKPIsData {
    // Réservations
    arrivals_today: number;
    arrivals_yesterday: number;
    arrivals_trend: number;
    departures_today: number;
    arrivals_tomorrow: number;
    departures_tomorrow: number;
    guests_on_site: number;
    guests_trend: number;
    occupancy_rate: number;

    // Communications
    communications_total_30d: number;
    communications_trend: number;
    emails_sent_30d: number;
    sms_sent_30d: number;
    whatsapp_sent_30d: number;

    // Marketing
    marketing_revenue_30d: number;
    marketing_reservations_30d: number;
    revenue_trend: number;
}

/**
 * Hook pour récupérer les KPIs globaux du dashboard
 */
export function useDashboardKPIs() {
    const { currentFacility } = useStateContext();

    const url = currentFacility?.id
        ? `/dashboard/kpis?facility_id=${currentFacility.id}`
        : '';

    return useApiQuery<{ data: DashboardKPIsData }>(url, {}, {
        enabled: !!currentFacility?.id && url !== '',
        staleTime: 60000, // 1 minute
        refetchInterval: 300000, // Refresh every 5 minutes
    });
}
